import api from "../index";
import { apiUrl, constant } from "../../utils/constants";

export const GetTermsAndConditions = () => api.get(`${constant.V1}${apiUrl.pages}${apiUrl.terms_and_conditions}/`)
export const GetPrivacyPolicy = () => api.get(`${constant.V1}${apiUrl.pages}${apiUrl.privacy_policy}/`)
export const GetFaqs = () => api.get(`${constant.V1}${apiUrl.faqs}/`)